module.exports = __webpack_public_path__ + "static/media/GTEestiDisplay-Light.1aac0345.woff";